// src/components/library/AlbumGrid.jsx
import React from 'react';
import { useLibrary } from '../../context/LibraryContext';

const AlbumGrid = ({ onOpenModal }) => {
  const { releases, setSelectedRelease } = useLibrary();
  
  const handleAlbumClick = (release) => {
    setSelectedRelease(release);
    onOpenModal();
  };
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {releases.map((release) => (
        <div
          key={release.id}
          className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-1 cursor-pointer"
          onClick={() => handleAlbumClick(release)}
        >
          <div className="aspect-square overflow-hidden">
            <img
              src={release.coverImage}
              alt={release.title}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="p-4">
            <h3 className="text-lg font-semibold text-gray-100 mb-1">{release.title}</h3>
            <p className="text-sm text-gray-400">
              {new Date(release.releaseDate).getFullYear()}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlbumGrid;